export const isObjectOfTypeQuestionnaire = (data: any): data is Questionnaire => {
  return data && data.type && Array.isArray(data.questions) && data.questions.length > 0;
};

export const isArrayOfTypeResultSet = (data: any[]): data is QuestionnaireResultSet[] => {
  return data && Array.isArray(data) && data.length > 0;
};

export interface QuestionnaireResultSetQuestion {
  id: string;
  value: number | boolean | string | Array<number | boolean | string>;
  type: string;
}

export interface QuestionnaireResultSet {
  id: string;
  questions: QuestionnaireResultSetQuestion[];
}
export interface AdditionalQuestionnaireResultSet extends QuestionnaireResultSet {
  extends: string[];
}

export interface ConditionalSelection {
  value: boolean | string | null;
  conditions?: Condition[];
}

export interface Condition {
  type: string;   // isEqual, isGreater, isLess
  refId: string;
  value: boolean | string | number | null | Array<boolean | string | number>;
  conditions?: Condition[];
}

export interface KeyValueProp {
  key: string;
  value: string;
}

export interface Question {
  id: string;
  label: string;
  hint?: string;
  type: string;
  required: boolean;
  options?: KeyValueProp[];
  conditions?: Condition[];
  conditionalSelection?: ConditionalSelection[];
}

export interface Questionnaire {
  type: string;
  questions: Question[];
  additionalQuestions: Question[];
}

export interface QuestionnaireWithResultSets {
  id?: string;
  description: string;
  questionnaire: Questionnaire;
  resultSets: QuestionnaireResultSet[];
  additionalResultSets: AdditionalQuestionnaireResultSet[];
}
